var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-text"},[_c('span',{staticClass:"c-status-badge",class:'c-status-badge--' + _vm.variant},[_vm._v("\n        "+_vm._s(_vm.$t( "SUBSCRIPTIONS_status" + _vm.Value ))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }